import React from 'react';

// Context to provide react-hook-form methods for the checkout form
const CheckoutFormContext = React.createContext(null);

export default CheckoutFormContext;
